import styled from "styled-components";

export const Styled = styled.div<{ tiny?: boolean }>`
  > span {
    font-size: ${({ tiny }) => (tiny ? "10px" : "inherit")};
    margin-right: 4px;
  }
`;
